function isGif(message) {
    return message.file !== undefined && message.file.type === 'image/gif';
}
function getDuration(message) {
    if (message.audio !== undefined) {
        return message.audio.duration;
    }
    else if (message.video !== undefined) {
        return message.video.duration;
    }
    else if (message.voip !== undefined && message.voip.duration) {
        return message.voip.duration;
    }
    return undefined;
}
export function hasMetaInfo(message) {
    return isGif(message) || getDuration(message) !== undefined;
}
export default [
    function () {
        return {
            restrict: 'EA',
            transclude: true,
            scope: {},
            bindToController: {
                message: '=eeeMessage',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.$onInit = function () {
                        const message = this.message;
                        this.isGif = isGif(message);
                        this.duration = getDuration(message);
                    };
                }],
            template: `
                <span ng-if="ctrl.isGif" class="message-meta-item">GIF</span>
                <span ng-if="ctrl.duration !== undefined" class="message-meta-item message-duration">
                    <md-icon class="material-icons">av_timer</md-icon>
                    {{ctrl.duration | duration}}
                </span>
            `,
        };
    },
];
